import { render } from "./CustomBrandingTheme.vue?vue&type=template&id=83ff52de&scoped=true&ts=true"
import script from "./CustomBrandingTheme.vue?vue&type=script&lang=ts"
export * from "./CustomBrandingTheme.vue?vue&type=script&lang=ts"

import "./CustomBrandingTheme.vue?vue&type=style&index=0&id=83ff52de&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83ff52de"]])

export default __exports__